<ion-header class="ion-no-border" color="primary">
	<ion-toolbar color="primary">
		<ion-buttons slot="start">
			<ion-button (click)="back()">back</ion-button>
		</ion-buttons>

		<ion-title>
			<div class="ion-text-wrap">calculate recipe</div>
		</ion-title>

		<ion-buttons slot="end"></ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="recipe-modal">
	<!-- No selector page -->
	<div *ngIf="form">
		<app-patient-info [patients]="patients"></app-patient-info>

		<div class="order-select-row" *ngIf="patients.length && StorageService.isOrderValidationEnforced">
			<app-order-select
				[orders]="orders"
				[orderObject]="orderObject"
				[(selectedOrder)]="selectedOrder"
				(selectedOrderChange)="handleSelectOrderChanged($event)"
				[showChangeOrder]="true"
				(changeOrder)="changeOrder()"
				[selectedCalorie]="finalCalorieDensity"
				#orderSelectRef
			>
			</app-order-select>
		</div>

		<!-- Calculator Mode (tab toggle) -->
		<section class="calculator-mode-container">
			<div class="calculator-mode-title">
				<h1>Calculator Mode</h1>

				<button
					id="calculator-mode-info-trigger"
					type="button"
					class="calculator-mode-info-button"
					aria-label="About calculator modes -  Calculator mode info"
				>
					<ion-icon
						name="information-circle-outline"
						aria-hidden="true"
					></ion-icon>
				</button>
			</div>

			<ion-popover
				trigger="calculator-mode-info-trigger"
				triggerAction="click"
				side="right"
				alignment="center"
				[showBackdrop]="false"
				[arrow]="true"
				cssClass="calculator-mode-info-popover"
			>
				<ng-template>
					<div class="calculator-mode-info-content">
						Choose from three preparation options to create recipes and optimize
						the use of human milk: Volume on Hand, Desired Volume, or Manual Prep
					</div>
				</ng-template>
			</ion-popover>

			<ion-segment
				class="calculator-mode-segment"
				mode="ios"
				[value]="mode"
				(ionChange)="handleModeToggleChange($event)"
			>
				<ion-segment-button [value]="RecipeMode.DV" [disabled]="isRestrictedOnlyMode"
					>Desired Volume</ion-segment-button
				>
				<ion-segment-button [value]="RecipeMode.VOH" [disabled]="isRestrictedOnlyMode"
					>Volume On Hand</ion-segment-button
				>
				<ion-segment-button [value]="RecipeMode.MP"
					>Manual Prep</ion-segment-button
				>
			</ion-segment>
		</section>

		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<!-- Calculator inputs -->
			<div class="calculator-form">
				<app-urc-card title="Volume Calculator">
					<div [class]="getClassForVolumeCalculatorFields()">
						<ion-label *ngIf="mode !== RecipeMode.VOH">
							<p class="volume-input-label">
								<span>Volume per Feed</span>
							</p>
							<ion-input
								(ionInput)="handleFeedInputsChanged()"
								aria-label="volume per feed"
								fill="outline"
								formControlName="volumePerFeed"
								type="number"
								inputmode="decimal"
								labelPlacement="stacked"
								placeholder=""
								debounce="250"
								[class.greyed-out]="volumeManuallyEdited"
							>
								<div slot="end" class="slot-unit">
									<span>(mL)</span>
								</div>
							</ion-input>
						</ion-label>

						<fa-icon
							*ngIf="mode !== RecipeMode.VOH"
							class="operator-icon"
							[icon]="faPlus"
							[fixedWidth]="true"
							size="lg"
							slot="start"
						></fa-icon>

						<ion-label *ngIf="mode !== RecipeMode.VOH">
							<p class="volume-input-label">
								<span>Overfill per Feed</span>
							</p>
							<ion-input
								(ionInput)="handleFeedInputsChanged()"
								aria-label="overfill per feed"
								fill="outline"
								formControlName="overfillPerFeed"
								type="number"
								inputmode="decimal"
								labelPlacement="stacked"
								placeholder=""
								debounce="250"
								[class.greyed-out]="volumeManuallyEdited"
							>
								<div slot="end" class="slot-unit">
									<span>(mL)</span>
								</div>
							</ion-input>
						</ion-label>

						<fa-icon
							*ngIf="mode !== RecipeMode.VOH"
							class="operator-icon"
							[icon]="faTimes"
							[fixedWidth]="true"
							size="lg"
							slot="start"
						></fa-icon>

						<ion-label *ngIf="mode !== RecipeMode.VOH">
							<p class="volume-input-label">
								<span>Number of Feeds</span>
							</p>
							<ion-input
								(ionInput)="handleFeedInputsChanged()"
								aria-label="number of feeds"
								fill="outline"
								formControlName="numberOfFeeds"
								type="number"
								inputmode="numeric"
								step="1"
								(keydown)="blockNonWholeNumberKeys($event)"
								labelPlacement="stacked"
								placeholder=""
								debounce="250"
								[class.greyed-out]="volumeManuallyEdited"
							></ion-input>
						</ion-label>

						<fa-icon
							*ngIf="mode !== RecipeMode.VOH"
							class="operator-icon"
							[icon]="faEquals"
							[fixedWidth]="true"
							size="lg"
							slot="start"
						></fa-icon>

						<ion-label *ngIf="mode !== RecipeMode.VOH">
							<p class="main-volume-input-label">
								<span>Desired Final Volume</span>
							</p>
							<ion-input
								(ionInput)="handleVolumeDirectEdit()"
								aria-label="desired final volume"
								fill="outline"
								formControlName="volume"
								type="number"
								inputmode="numeric"
								step="1"
								(keydown)="blockNonWholeNumberKeys($event)"
								labelPlacement="stacked"
								placeholder=""
								debounce="250"
								data-testid="recipe_volume"
								class="main-volume-input"
							>
								<div slot="end" class="slot-unit">
									<span>(mL)</span>
								</div>
							</ion-input>
						</ion-label>

						<ion-label *ngIf="mode === RecipeMode.VOH">
							<p class="main-volume-input-label">
								<span>Volume on Hand</span>
							</p>
							<ion-input
								(ionInput)="handleVolumeDirectEdit()"
								aria-label="volume on hand"
								fill="outline"
								formControlName="volumeVOH"
								type="number"
								inputmode="numeric"
								step="1"
								(keydown)="blockNonWholeNumberKeys($event)"
								labelPlacement="stacked"
								placeholder=""
								debounce="250"
								data-testid="recipe_volume_voh"
								class="main-volume-input"
							>
								<div slot="end" class="slot-unit">
									<span>(mL)</span>
								</div>
							</ion-input>
						</ion-label>
					</div>
				</app-urc-card>
				<app-urc-card title="Ingredients">
					<!-- Base -->
					<ion-label class="base-input">
						<p class="volume-input-label">Base</p>
						<div class="select-with-clear">
							<div class="urc-select-field">
								<fa-icon
									class="urc-select-field__icon"
									[icon]="faSearch"
									[fixedWidth]="true"
								></fa-icon>
								<ion-select
									[interfaceOptions]="defaultSelectOptions"
									[compareWith]="compareByProductId"
									aria-label="base"
									fill="outline"
									labelPlacement="stacked"
									interface="popover"
									formControlName="fulfillmentBase"
									placeholder="Select desired base"
									data-testid="recipe_base"
								>
									<ion-select-option
										*ngFor="let opt of fulfillmentBaseOptions"
										[value]="opt"
										[disabled]="isProductSelectedElsewhere(opt.productId, form.value.fulfillmentBase?.productId)"
									>
										{{ opt.displayName || opt.productName }}
									</ion-select-option>
								</ion-select>
								<button
									*ngIf="form.value.fulfillmentBase"
									type="button"
									class="clear-select-btn"
									aria-label="Clear base"
									(click)="clearFulfillmentBase()"
								>
									<fa-icon [icon]="faTimes"></fa-icon>
								</button>
							</div>
						</div>
					</ion-label>

					<!-- One .additive-input row per additive, each paired with its own Target Density -->
					<ng-container formArrayName="fulfillmentAdditives">
						<div
							*ngFor="let ctrl of getAdditivesArray().controls; let i = index"
							[formGroupName]="i"
							class="additive-input"
						>
							<ion-label class="ion-text-wrap">
								<p class="volume-input-label">Additive</p>
								<div class="select-with-clear">
									<div class="urc-select-field">
										<fa-icon
											class="urc-select-field__icon"
											[icon]="faSearch"
											[fixedWidth]="true"
										></fa-icon>
										<ion-select
											[interfaceOptions]="defaultSelectOptions"
											[compareWith]="compareByProductId"
											aria-label="additive"
											fill="outline"
										formControlName="additive"
											interface="popover"
											labelPlacement="stacked"
											placeholder="Select additive"
										>
											<ion-select-option
												*ngFor="let opt of fulfillmentAdditiveOptions"
												[value]="opt"
												[disabled]="isProductSelectedElsewhere(opt.productId, ctrl.value?.additive?.productId)"
											>
												{{ opt.displayName || opt.productName }}
											</ion-select-option>
										</ion-select>
										<button
											*ngIf="ctrl.value?.additive"
											type="button"
											class="clear-select-btn"
											aria-label="Clear additive"
											(click)="clearAdditive(i)"
										>
											<fa-icon [icon]="faTimes"></fa-icon>
										</button>
									</div>
								</div>
							</ion-label>

							<ion-label class="target-density" *ngIf="mode !== RecipeMode.MP">
								<p class="volume-input-label">Target Calorie Density</p>
								<div class="select-with-clear">
									<ion-select
										[interfaceOptions]="defaultSelectOptions"
										[class.input-error]="!!getAdditiveDensityErrorMessage(i)"
										aria-label="calorie density"
										fill="outline"
										formControlName="calorieDensity"
										interface="popover"
										labelPlacement="stacked"
										placeholder="Select calorie density"
									>
										<ion-select-option
											*ngFor="let calorieDensity of getCalorieDensityOptionsForAdditive(i)"
											[value]="calorieDensity"
										>
											{{ formatDensity(calorieDensity) }}
										</ion-select-option>
									</ion-select>
									<button
										*ngIf="ctrl.get('calorieDensity')?.value != null"
										type="button"
										class="clear-select-btn"
										aria-label="Clear calorie density"
										(click)="clearAdditiveDensity(i)"
									>
										<fa-icon [icon]="faTimes"></fa-icon>
									</button>
								</div>
								<ion-note
									*ngIf="getAdditiveDensityErrorMessage(i)"
									color="danger"
									class="field-error-note"
								>
									{{ getAdditiveDensityErrorMessage(i) }}
								</ion-note>
							</ion-label>
						</div>
					</ng-container>

					<!-- URC Exempt Additives (passthrough — not sent to calculator) -->
					<ng-container *ngIf="urcExemptAdditiveItems.length">
						<div
							*ngFor="let item of urcExemptAdditiveItems"
							class="additive-input"
						>
							<ion-label>
								<p class="volume-input-label">Calculator Exempt Additive</p>
								<div class="urc-select-field">
									<fa-icon
										class="urc-select-field__icon"
										[icon]="faSearch"
										[fixedWidth]="true"
									></fa-icon>
									<ion-select
										[interfaceOptions]="defaultSelectOptions"
										aria-label="calculator exempt additive"
										fill="outline"
										labelPlacement="stacked"
										interface="popover"
										[value]="item"
										[disabled]="true"
									>
										<ion-select-option [value]="item">{{ item.productName }}</ion-select-option>
									</ion-select>
								</div>
							</ion-label>
						</div>
					</ng-container>

					<!-- Non-Caloric Additives (passthrough — not sent to calculator) -->
					<ng-container *ngIf="nonCaloricAdditiveItems.length">
						<div
							*ngFor="let item of nonCaloricAdditiveItems"
							class="additive-input"
						>
							<ion-label>
								<p class="volume-input-label">Non-Caloric Additive</p>
								<div class="urc-select-field">
									<fa-icon
										class="urc-select-field__icon"
										[icon]="faSearch"
										[fixedWidth]="true"
									></fa-icon>
									<ion-select
										[interfaceOptions]="defaultSelectOptions"
										aria-label="non-caloric additive"
										fill="outline"
										labelPlacement="stacked"
										interface="popover"
										[value]="item"
										[disabled]="true"
									>
										<ion-select-option [value]="item">{{ item.productName }}</ion-select-option>
									</ion-select>
								</div>
							</ion-label>
						</div>
					</ng-container>

					<!-- Manual Prep: single target density shared across all ingredients -->
					<ion-label *ngIf="mode === RecipeMode.MP" class="target-density manual-density">
						<p class="volume-input-label">Target Calorie Density</p>
						<div class="select-with-clear">
							<ion-select
								[interfaceOptions]="defaultSelectOptions"
								[class.input-error]="!!manualPrepDensityErrorMessage"
								aria-label="manual prep target density"
								fill="outline"
								formControlName="manualPrepCalorieDensity"
								interface="popover"
								labelPlacement="stacked"
								placeholder="Select target density"
								(ionChange)="handleManualPrepDensityChanged()"
							>
								<ion-select-option
									*ngFor="let density of getManualPrepCalorieDensityOptions()"
									[value]="density"
								>
									{{ formatDensity(density) }}
								</ion-select-option>
							</ion-select>
							<button
								*ngIf="form.value.manualPrepCalorieDensity != null"
								type="button"
								class="clear-select-btn"
								aria-label="Clear target density"
								(click)="clearManualPrepDensity()"
							>
								<fa-icon [icon]="faTimes"></fa-icon>
							</button>
						</div>
						<ion-note
							*ngIf="manualPrepDensityErrorMessage"
							color="danger"
							class="field-error-note"
						>
							{{ manualPrepDensityErrorMessage }}
						</ion-note>
					</ion-label>
				</app-urc-card>

				<div class="buttons">
					<button
						type="submit"
						[disabled]="!canSubmit(mode, form)"
						class="nav-btn"
						data-testid="recipe_calculator__submit_button"
					>
						Submit
					</button>
				</div>
			</div>
		</form>
	</div>
</ion-content>
